import React from 'react';
import { 
  LayoutDashboard, 
  PlusCircle, 
  FolderKanban, 
  FileStack, 
  ClipboardCheck, 
  Calculator, 
  Users2, 
  Settings,
  Mail,
  Video,
  Calendar,
  FileText,
  Layers,
  AlertTriangle,
  GitMerge,
  UserCheck,
  BarChart2,
  Target
} from 'lucide-react';
import { Path } from '../App';

interface SidebarProps {
  currentPath: Path;
  onNavigate: (path: Path) => void;
}

export default function Sidebar({ currentPath, onNavigate }: SidebarProps) {
  // Group navigation items by category
  const navGroups = [
    {
      name: 'Core',
      items: [
        { name: 'Dashboard', icon: <LayoutDashboard className="w-5 h-5" />, path: '/' as Path },
        { name: 'New Deal', icon: <PlusCircle className="w-5 h-5" />, path: '/new-deal' as Path },
        { name: 'Deal Pipeline', icon: <FolderKanban className="w-5 h-5" />, path: '/pipeline' as Path }
      ]
    },
    {
      name: 'Deal Management',
      items: [
        { name: 'Data Room', icon: <FileStack className="w-5 h-5" />, path: '/data-room' as Path },
        { name: 'Due Diligence', icon: <ClipboardCheck className="w-5 h-5" />, path: '/due-diligence' as Path },
        { name: 'Financial Models', icon: <Calculator className="w-5 h-5" />, path: '/financial' as Path },
        { name: 'Documents', icon: <FileText className="w-5 h-5" />, path: '/documents' as Path }
      ]
    },
    {
      name: 'Integration & Risk',
      items: [
        { name: 'Integration', icon: <GitMerge className="w-5 h-5" />, path: '/integration' as Path },
        { name: 'Risk Management', icon: <AlertTriangle className="w-5 h-5" />, path: '/risk' as Path },
        { name: 'Compliance', icon: <Layers className="w-5 h-5" />, path: '/compliance' as Path }
      ]
    },
    {
      name: 'Stakeholders',
      items: [
        { name: 'Team', icon: <Users2 className="w-5 h-5" />, path: '/team' as Path },
        { name: 'Stakeholders', icon: <UserCheck className="w-5 h-5" />, path: '/stakeholders' as Path }
      ]
    },
    {
      name: 'Communication',
      items: [
        { name: 'Email', icon: <Mail className="w-5 h-5" />, path: '/email' as Path },
        { name: 'Meetings', icon: <Video className="w-5 h-5" />, path: '/meetings' as Path },
        { name: 'Calendar', icon: <Calendar className="w-5 h-5" />, path: '/calendar' as Path }
      ]
    },
    {
      name: 'Outreach',
      items: [
        { name: 'Campaigns', icon: <Target className="w-5 h-5" />, path: '/campaigns' as Path }
      ]
    },
    {
      name: 'Analytics',
      items: [
        { name: 'Analytics', icon: <BarChart2 className="w-5 h-5" />, path: '/analytics' as Path }
      ]
    },
    {
      name: 'Settings',
      items: [
        { name: 'Settings', icon: <Settings className="w-5 h-5" />, path: '/settings' as Path }
      ]
    }
  ];

  return (
    <div className="w-64 bg-white border-r border-gray-200 min-h-screen">
      <div className="flex items-center h-16 px-4 border-b border-gray-200">
        <h1 className="text-xl font-bold text-gray-900">M&A Suite</h1>
      </div>
      
      <nav className="mt-4">
        {navGroups.map((group) => (
          <div key={group.name} className="px-4 mb-4">
            <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
              {group.name}
            </h2>
            {group.items.map((item) => (
              <button
                key={item.name}
                onClick={() => onNavigate(item.path)}
                className={`flex items-center w-full px-4 py-2 text-sm font-medium rounded-lg mb-1 ${
                  currentPath === item.path
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span className="mr-3">{item.icon}</span>
                {item.name}
              </button>
            ))}
          </div>
        ))}
      </nav>
    </div>
  );
}